import React from "react";
import { Button } from "semantic-ui-react";
import ConfirmAction from "../dialogs/ConfirmAction";
import { printContent } from "../common/PrintContent";

class CaseButtons extends React.Component {
  state = {
    show: false,
  };

  closeConfirm = () => {
    this.setState({ show: false });
  };

  showConfirm = () => {
    this.setState({ show: true });
  };

  dialogClose = () => {
    this.setState({ show: false });
  };

  printCase = () => {
    printContent("Edit Case");
  };

  dialogSubmit = () => {
    this.setState({ show: false });
    this.props.deleteCase();
  };

  render() {
    return (
      <div>
        <Button onClick={() => this.props.listFolders()}>BACK</Button>
        <Button onClick={() => this.props.updateCaseActivitiesPane()}>
          ADD/DELETE ACTIVITIES
        </Button>
        <Button onClick={() => this.printCase()}>PRINT</Button>
        <Button onClick={() => this.showConfirm()}>DELETE CASE</Button>
        <Button onClick={() => this.props.updateCasePricing()}>
          UPDATE CASE PRICING
        </Button>
        <ConfirmAction
          dialogProps={{
            title: "Delete Case",
            body: "Are you sure, do you want to delete this case?",
            comfirmButtonText: "Yes",
            cancelButtonText: "No",
          }}
          active={this.state.show}
          dialogClose={this.dialogClose}
          dialogSubmit={this.dialogSubmit}
        />
      </div>
    );
  }
}

export default CaseButtons;

export const getActivitiesEditButtons = (props) => (
  <div>
    <Button onClick={() => props.saveActivities()}>SAVE</Button>
    <Button onClick={() => props.clearActivitiesSelection()}>REMOVE ALL</Button>
    <Button onClick={() => props.cancelActivitiesSelection()}>CANCEL</Button>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/myaccount/CaseEditButtons.js